(function() {
  'use strict';

  angular.module('claims', [
    'ngResource',
    'dnErrorDisplay',
    'common',
    'ui.bootstrap'
  ]);
})();